import React from 'react';

import { Row, Col, Space, Typography } from 'antd';
import { t } from "../../../i18n";
const { Title, Text} = Typography;

const ColorPreview = (props) => {
  return (
    <>
      {/* <Col>

      </Col> */}
      {/* <center> */}
        <Col >
        <Space>
          {t("Preview:")} 
            <div id="color" style={{ width: "25px", height: "25px" }} ></div>
            <div id="status"></div>
          </Space>
        </Col>
      {/* </center> */}
    </>
  );
};

export default ColorPreview;